import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-footer-contact',
    templateUrl: './footer-contact.component.html',
    styleUrls: ['./footer-contact.component.scss'],
    standalone: false
})
export class FooterContactComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit() {
  }

}
